export type ScriptIllegalSubmitGateResult = "pass" | "show_modal" | "error";

export type RunScriptIllegalSubmitGateParams = {
  trimmed: string;
  scriptRiskWords: string[];
  failMessage: string;
  onCheckScriptIllegal: (text: string) => Promise<string[]>;
  /** 当前文案是否与最近一次接口检测的文案一致 */
  onIsScriptIllegalCheckFreshForText?: (text: string) => boolean;
  onCheckFailed: (message: string) => void;
};

/**
 * 口播违禁词提交流程：首次对当前文案调接口；同一文案再次提交仅用本地 scriptRiskWords 判断，不再请求接口。
 * 调用方需保证仅在「违禁词开关 + 口播模式 + 有正文 + 有检测函数」时调用。
 */
export async function runScriptIllegalSubmitGate(
  params: RunScriptIllegalSubmitGateParams
): Promise<ScriptIllegalSubmitGateResult> {
  const {
    trimmed,
    onCheckScriptIllegal,
    scriptRiskWords,
    onIsScriptIllegalCheckFreshForText,
    onCheckFailed,
    failMessage,
  } = params;

  let words: string[];
  try {
    if (onIsScriptIllegalCheckFreshForText?.(trimmed)) {
      words = scriptRiskWords;
    } else {
      words = await onCheckScriptIllegal(trimmed);
    }
  } catch (e) {
    console.error(e);
    onCheckFailed(failMessage);
    return "error";
  }

  const stillHasRisk = words.some((w) => w && trimmed.includes(w));
  if (stillHasRisk) return "show_modal";
  return "pass";
}
